/* IDI MIRROR — B2B 询价清单逻辑（原生 JS，无依赖）
   规则：每个"型号+尺寸"独立算档；同 SKU 重复加入自动合并；数量变化重算档位；
        1–10 / 11–50 两档价；超过 50 pcs 仍按 11–50 价计（大单量价走 WhatsApp）；无价项不计入合计。 */
(function () {
  var root = document.querySelector('.idi') || document.body;
  if (!root) return;
  /* 配置来源：商品页取 .idi 上的 data-*；其它页面（首页/集合页）取 #idi-cfg（全站片段输出） */
  var cfg = document.querySelector('#idi-cfg');
  function D(k) { return root.dataset[k] || (cfg && cfg.dataset[k]) || ''; }
  var KEY = 'idi_inquiry_v1';
  var handle = D('handle') || 'global';
  var model = D('model');
  var currency = D('currency') || 'CNY';
  var symbol = '¥';
  (function () {
    var s = (root.querySelector('.idi-size[data-t1]') || {}).dataset;
    var txt = (s && (s.t2 || s.t1)) || '';
    var m = txt.match(/^[^\d\-+]*/);
    if (m && m[0].trim()) symbol = m[0].trim();
  })();

  var el = {
    sizes: root.querySelectorAll('.idi-size'),
    qty: root.querySelector('#idi-qty'),
    p: [1, 2].map(function (i) { return root.querySelector('#idi-price-' + i); }),
    unit: root.querySelector('#idi-unit'),
    sub: root.querySelector('#idi-sub'),
    add: root.querySelector('#idi-add'),
    added: root.querySelector('#idi-added'),
    count: root.querySelector('#idi-count'),
    open: root.querySelector('#idi-open'),
    drawer: document.querySelector('#idi-drawer'),
    close: document.querySelector('#idi-close'),
    veil: document.querySelector('#idi-veil'),
    scroll: document.querySelector('.idi-drawer__scroll'),
    items: document.querySelector('#idi-items'),
    total: document.querySelector('#idi-total'),
    fabN: document.querySelector('#idi-fab-n'),
    status: document.querySelector('#idi-status'),
    bulk: document.querySelector('#idi-bulk'),
    submit: document.querySelector('#idi-submit')
  };

  /* 浮层搬到 body 末尾：彻底脱离主题的层叠上下文，避免被 sticky header 盖住（关闭按钮点不到） */
  try {
    [el.drawer, el.veil, document.querySelector('#idi-fab')].forEach(function (n) {
      if (n && n.parentNode && n.parentNode !== document.body) document.body.appendChild(n);
    });
  } catch (e) { /* 忽略 */ }

  var state = { size: '', tiers: ['', ''] };
  if (el.sizes.length) {
    var first = el.sizes[0];
    state.size = first.dataset.size;
    state.tiers = [first.dataset.t1, first.dataset.t2];
  }

  /* 只公开两档价：1–10 / 11–50；超过 50 pcs 仍然按 11–50 价计（更大的量价只在 WhatsApp 谈） */
  function tierOf(q) {
    if (q >= 1 && q <= 10) return { i: 0, label: '1–10 pcs' };
    if (q >= 11 && q <= 50) return { i: 1, label: '11–50 pcs' };
    if (q > 50) return { i: 1, label: 'Over 50 pcs' };
    return { i: -1, label: '' };
  }
  function unitFor(q) {
    var t = tierOf(q);
    if (t.i < 0) return '';
    return state.tiers[t.i] || '';
  }

  function paint() {
    if (!el.p[0]) return;                          /* 无商品面板的页面（首页等） */
    el.p[0].textContent = state.tiers[0] || '';
    el.p[1].textContent = state.tiers[1] || '';
    recalc();
  }
  function recalc() {
    if (!el.qty || !el.unit || !el.sub) return;   /* 无商品面板的页面（首页等）不参与计算 */
    var q = parseInt(el.qty.value, 10) || 0;
    var unit = unitFor(q);
    el.unit.textContent = unit || (q > 0 ? 'Pending Quote' : '—');
    el.sub.textContent = unit ? symbol + (num(unit) * q).toFixed(2) : (q > 0 ? 'Pending Quote' : '—');
    syncBulk();
  }

  /* 超过 50 pcs 的 WhatsApp 询价按钮：自动带上当前型号 / 尺寸 / 数量 */
  function syncBulk() {
    if (!el.bulk) return;
    var waNum = D('wa') || '';
    var q = parseInt(el.qty.value, 10) || 0;
    var qtyTxt = q > 50 ? (q + ' pcs') : 'over 50 pcs';
    var msg = 'Hi IDI MIRROR, please quote your best price: ' +
              (state.model || root.dataset.model || '') + ' / ' + (state.size || '') + ' / ' + qtyTxt + ' (bulk order).';
    el.bulk.href = 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(msg);
  }
  function num(s) {
    var m = String(s).match(/[\d,]+(\.\d+)?/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : 0;
  }

  el.sizes.forEach(function (b) {
    b.addEventListener('click', function () {
      el.sizes.forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      state.size = b.dataset.size;
      state.tiers = [b.dataset.t1, b.dataset.t2];
      paint();
      syncThemeVariant(state.size);
    });
  });
  if (el.qty) el.qty.addEventListener('input', recalc);

  /* 与主题的变体选择器保持同步（点同尺寸的 radio） */
  function syncThemeVariant(size) {
    try {
      var inputs = document.querySelectorAll('form[action*="/cart/add"] input[type="radio"]');
      inputs.forEach(function (inp) {
        var lab = inp.closest('label');
        var txt = ((lab && lab.textContent) || inp.value || '').trim();
        if (txt.indexOf(size.slice(0, 6)) === 0 || txt === size) inp.click();
      });
    } catch (e) { /* 忽略 */ }
  }

  /* 隐藏主题里的 MOQ 选项（档位由数量决定，客户不能手选低价档） */
  function hideMoq() {
    document.querySelectorAll('form[action*="/cart/add"] fieldset, .product-form__input').forEach(function (f) {
      var lg = f.querySelector('legend');
      if (lg && /moq/i.test(lg.textContent || '')) f.style.display = 'none';
    });
  }
  hideMoq();
  setTimeout(hideMoq, 800);

  /* ---------------- 清单存取 ---------------- */
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    render();
  }
  /* 抽屉顶部的常驻结果提示（成功/失败都一定看得见，不随滚动区滚动） */
  /* 版本号由 JS 自己写入：页面 HTML 会被 CDN/浏览器缓存，写在 HTML 里会显示旧版号，
     写在 JS 里则永远真实反映“当前运行的 JS 是哪一版”。 */
  var BUILD = 'v12';
  try { var bEl = document.querySelector('#idi-build'); if (bEl) { bEl.textContent = BUILD; } } catch (e) {}

  function status(msg, kind) {
    if (!el.status) return;
    el.status.textContent = msg;
    el.status.className = 'idi-status' + (kind ? ' idi-status--' + kind : '');
    el.status.hidden = false;
  }

  function addItem() {
    var q = parseInt(el.qty.value, 10) || 0;
    if (q < 1 || !state.size) { return; }
    var unit = unitFor(q);
    var img = root.querySelector('.idi-item__img');
    var thumb = document.querySelector('.product__media img, .media img, .product-media img');
    var list = read();
    var key = handle + '|' + state.size;
    var found = null;
    list.forEach(function (x) { if (x.key === key) found = x; });
    if (found) { found.qty = found.qty + q; }
    else {
      list.push({ key: key, handle: handle, model: model, size: state.size, qty: q,
                  image: thumb ? (thumb.currentSrc || thumb.src) : '' });
    }
    write(list);
    if (el.added) {
      el.added.textContent = '✓ Added — your Inquiry List now has ' + list.length + ' item(s).';
      el.added.hidden = false;
      setTimeout(function () { if (el.added) el.added.hidden = true; }, 4500);
    }
    render();                       // 立即刷新件数（模块内按钮 + 浮动按钮）
    /* 不再自动弹出清单（默认收起）；要看清单点“My Inquiry List”或右下角浮动按钮 */
  }

  function render() {
    var list = read();
    if (el.count) el.count.textContent = list.length;
    if (el.fabN) el.fabN.textContent = list.length;      // 浮动按钮上的件数
    syncHeaderBadge();                                   // 右上角购物车图标上的件数
    if (!el.items) return;
    if (!list.length) { el.items.innerHTML = '<p class="idi-empty">No items yet.</p>'; }
    else {
      el.items.innerHTML = list.map(function (x, i) {
        var u = unitForQ(x.handle, x.qty);
        var line = u ? { p: symbol + (num(u) * x.qty).toFixed(2), u: u }
                     : { p: 'Pending Quote', u: 'Pending Quote' };
        return '<div class="idi-item">' +
          (x.image ? '<img class="idi-item__img" src="' + x.image + '" alt="">' : '') +
          '<div class="idi-item__main">' +
            '<div class="idi-item__model">' + x.model + '</div>' +
            '<div class="idi-item__sub">' + x.size + ' · ' + currency + '</div>' +
            '<div class="idi-item__row">' +
              '<input type="number" min="1" value="' + x.qty + '" data-i="' + i + '" class="idi-item-qty">' +
              '<span>' + line.u + '</span>' +
              '<button class="idi-item__del" data-del="' + i + '">Remove</button>' +
            '</div>' +
            '<div class="idi-item__sub">Subtotal: ' + line.p + '</div>' +
          '</div></div>';
      }).join('');
      el.items.querySelectorAll('.idi-item-qty').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var l = read(); l[+inp.dataset.i].qty = Math.max(1, parseInt(inp.value, 10) || 1); write(l);
        });
      });
      el.items.querySelectorAll('[data-del]').forEach(function (b) {
        b.addEventListener('click', function () {
          var l = read(); l.splice(+b.dataset.del, 1); write(l);
        });
      });
    }
    /* 合计：只算有价的（pending 不计入） */
    var sum = 0, pending = 0;
    list.forEach(function (x) {
      var u = unitForQ(x.handle, x.qty);
      if (u) sum += num(u) * x.qty; else pending++;
    });
    if (el.total) {
      el.total.textContent = symbol + sum.toFixed(2) + (pending ? '  (+' + pending + ' pending quote)' : '');
    }
  }

  /* 其它商品的单价（从上次访问缓存里取；当前页用实时档位） */
  function unitForQ(h, q) {
    if (h === handle) return unitFor(q);
    var cache = {};
    try { cache = JSON.parse(localStorage.getItem('idi_tiers_v1')) || {}; } catch (e) {}
    var t = cache[h];
    if (!t) return '';
    var i = tierOf(q).i;
    return (i >= 0 && i <= 1) ? (t[i] || '') : '';
  }
  /* 缓存本页档位，供其它页面合计使用 */
  try {
    var cache = JSON.parse(localStorage.getItem('idi_tiers_v1')) || {};
    var all = {};
    el.sizes.forEach(function (b) {
      all[b.dataset.size] = [b.dataset.t1, b.dataset.t2];
    });
    cache[handle] = all[state.size] || ['', ''];
    localStorage.setItem('idi_tiers_v1', JSON.stringify(cache));
  } catch (e) {}

  /* ---------------- 抽屉（默认收起；关闭不删商品） ---------------- */
  function openDrawer() {
    if (el.drawer) el.drawer.hidden = false;
    if (el.veil) el.veil.hidden = false;
    if (fab) fab.hidden = true;                                    // 抽屉打开时隐藏浮动按钮（z-index 最高，会挡住底栏按钮）
    if (el.scroll) el.scroll.scrollTop = 0;                        // 每次打开从顶部开始
    try { document.body.style.overflow = 'hidden'; } catch (e) {}  // 锁住页面滚动，避免滚动错对象
  }
  function closeDrawer() {
    if (el.drawer) el.drawer.hidden = true;
    if (el.veil) el.veil.hidden = true;
    if (fab) fab.hidden = false;                                   // 关闭后恢复浮动按钮
    try { document.body.style.overflow = ''; } catch (e) {}
  }
  if (el.open) el.open.addEventListener('click', openDrawer);
  if (el.close) el.close.addEventListener('click', closeDrawer);
  if (el.veil) el.veil.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeDrawer(); });
  closeDrawer();                                   // 初始一律收起，绝不挡住产品页

  /* 右上角主题购物车图标 → 打开询价清单
     （本店不走 Shopify 原生购物车，否则客户会看到空车、甚至被要求登录） */
  function syncHeaderBadge() {
    try {
      var n = read().length;
      var link = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart');
      var bubble = document.querySelector('.cart-count-bubble');
      if (bubble) {
        var first = bubble.querySelector('span');
        if (first) first.textContent = n;
        bubble.style.display = n > 0 ? '' : 'none';
      }
      if (link) link.setAttribute('aria-label', 'Inquiry List: ' + n + ' item(s)');
    } catch (e) {}
  }
  /* 捕获阶段拦截，抢在主题自己的购物车抽屉逻辑之前 */
  document.addEventListener('click', function (ev) {
    var link = ev.target && ev.target.closest ? ev.target.closest('a[href*="/cart"]') : null;
    if (!link) return;
    var isHeaderCart = link.id === 'cart-icon-bubble' ||
      (link.classList && link.classList.contains('header__icon--cart')) ||
      (link.closest && link.closest('header'));
    if (!isHeaderCart) return;
    ev.preventDefault();
    ev.stopPropagation();
    openDrawer();
  }, true);
  if (el.add) el.add.addEventListener('click', addItem);
  /* ---------------- 提交询价：先写后台（Worker → 飞书），成功才给 RFQ ---------------- */
  var api = D('api').replace(/\/+$/, '');
  var apiProxy = D('apiProxy');                    /* 同源代理路径（/apps/rfq），中国大陆优先走它 */
  var wa = D('wa');
  var rate = D('rate');
  var version = D('version');
  var f = {
    name: document.querySelector('#idi-name'), company: document.querySelector('#idi-company'),
    country: document.querySelector('#idi-country'), wa: document.querySelector('#idi-wa'),
    email: document.querySelector('#idi-email'), notes: document.querySelector('#idi-notes')
  };
  var footBox = document.querySelector('#idi-foot'), doneBox = document.querySelector('#idi-done'),
      rfqEl = document.querySelector('#idi-rfq'), waSend = document.querySelector('#idi-wa-send'),
      errEl = document.querySelector('#idi-err'), doneNote = document.querySelector('#idi-done-note');
  var fab = document.querySelector('#idi-fab'), fabN = document.querySelector('#idi-fab-n');

  function rfqId() {
    var d = new Date(), p = function (n) { return (n < 10 ? '0' : '') + n; };
    return 'RFQ-' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '-' + Math.floor(1000 + Math.random() * 9000);
  }
  function line(x) {
    var u = unitForQ(x.handle, x.qty);
    return u ? { unit: symbol + num(u).toFixed(2) + ' USD/pc', amount: symbol + (num(u) * x.qty).toFixed(2) }
             : { unit: 'Pending Quote', amount: 'Pending Quote' };
  }
  function buildMessage(id, list) {
    var L = [id, 'Company: ' + f.company.value, 'Country: ' + f.country.value, 'Contact: ' + f.name.value,
             'WhatsApp: ' + f.wa.value];
    if (f.email.value) L.push('Email: ' + f.email.value);
    if (f.notes.value) L.push('Notes: ' + f.notes.value);
    L.push('', 'Items:');
    var sum = 0, pending = 0, i = 0;
    list.forEach(function (x) {
      i++;
      var l = line(x);
      if (l.amount !== 'Pending Quote') sum += num(l.amount); else pending++;
      L.push(i + ') ' + x.model + ' | ' + x.size + ' | ' + x.qty + ' pcs | ' + l.unit + ' | ' + l.amount);
    });
    L.push('', 'Estimated Product Total: ' + symbol + sum.toFixed(2) + ' USD (freight excluded' +
           (pending ? '; ' + pending + ' item(s) pending quotation' : '') + ')');
    if (rate) L.push('Rate: USD/CNY ' + rate + (version ? ' (RMB baseline ' + version + ')' : ''));
    L.push('Submitted: ' + new Date().toISOString().slice(0, 16).replace('T', ' '));
    return L.join('\n');
  }

  /* 幂等 token：同一次提交重试复用同一个 token，后端据此去重 */
  function idemToken() {
    var t = '';
    try { t = localStorage.getItem('idi_token_' + handle) || ''; } catch (e) {}
    if (!t) {
      t = 'tk-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      try { localStorage.setItem('idi_token_' + handle, t); } catch (e) {}
    }
    return t;
  }
  function clearToken() { try { localStorage.removeItem('idi_token_' + handle); } catch (e) {} }

  function payload() {
    var list = read();
    return {
      client_token: idemToken(),
      customer: { name: f.name.value.trim(), company: f.company.value.trim(), country: f.country.value.trim(),
                  whatsapp: f.wa.value.trim(), email: f.email.value.trim(), notes: f.notes.value.trim() },
      items: list.map(function (x) { return { handle: x.handle, size: x.size, qty: x.qty }; })
    };
  }
  function serverLine(l) {
    return (l.pending || l.unit === null || l.unit === undefined)
      ? { unit: 'Pending Quote', amount: 'Pending Quote' }
      : { unit: symbol + Number(l.unit).toFixed(2) + ' USD/pc', amount: symbol + Number(l.subtotal).toFixed(2) };
  }
  function messageFromServer(j) {
    var L = [j.rfq, 'Company: ' + f.company.value.trim(), 'Country: ' + f.country.value.trim(),
             'Contact: ' + f.name.value.trim(), 'WhatsApp: ' + f.wa.value.trim()];
    if (f.email.value.trim()) L.push('Email: ' + f.email.value.trim());
    if (f.notes.value.trim()) L.push('Notes: ' + f.notes.value.trim());
    L.push('', 'Items:');
    (j.items || []).forEach(function (l, i) {
      var t = serverLine(l);
      L.push((i + 1) + ') ' + l.model + ' | ' + l.size + ' | ' + l.qty + ' pcs | ' + t.unit + ' | ' + t.amount);
    });
    L.push('', 'Estimated Product Total: ' + symbol + Number(j.total).toFixed(2) + ' USD (freight excluded' +
           (j.pending ? '; ' + j.pending + ' item(s) pending quotation' : '') + ')');
    if (j.rate) L.push('Rate: USD/CNY ' + j.rate + (j.version ? ' (RMB baseline ' + j.version + ')' : ''));
    L.push('Submitted: ' + new Date().toISOString().slice(0, 16).replace('T', ' '));
    return L.join('\n');
  }
  function showDone(rfq, msg, record) {
    rfqEl.textContent = rfq;
    if (doneNote) doneNote.textContent = 'Your RFQ number is saved. Send it to us on WhatsApp (tap the button below) — we will confirm freight, delivery and PI, then you pay.';
    var url = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(msg);
    if (waSend) waSend.href = url;
    if (footBox) footBox.hidden = true;
    if (doneBox) doneBox.hidden = false;
    if (el.submit) el.submit.hidden = true;          // 成功后底部按钮换成 WhatsApp
    if (waSend) waSend.hidden = false;
    try {
      var hist = JSON.parse(localStorage.getItem('idi_rfq_history') || '[]');
      hist.push(record);
      localStorage.setItem('idi_rfq_history', JSON.stringify(hist));
    } catch (e) {}
    /* 不再自动打开 WhatsApp：中国大陆 wa.me 被墙，自动跳转会变成"一直加载的空白页"，
       客户会误以为提交失败。改为把 RFQ 编号显眼展示 + 由客户自己决定何时点 WhatsApp 按钮。 */
    try {
      if (doneBox) doneBox.scrollIntoView({ block: 'center' });
      if (el.scroll) el.scroll.scrollTop = el.scroll.scrollHeight;
    } catch (e) {}
  }

  if (el.submit) el.submit.addEventListener('click', function () {
    var list = read();
    if (!list.length) { alert('Your Inquiry List is empty.'); return; }
    var need = [['name', 'Name'], ['company', 'Company Name'], ['country', 'Country'], ['wa', 'WhatsApp Number']];
    var missing = [];
    need.forEach(function (p) { if (!f[p[0]] || !f[p[0]].value.trim()) missing.push(p[1]); });
    if (missing.length) { errEl.textContent = 'Please fill: ' + missing.join(', '); errEl.hidden = false; return; }
    errEl.hidden = true;

    /* 后端未配置：退回纯 WhatsApp 交接（明确不是后台记录） */
    if (!api) {
      var id0 = rfqId();
      showDone(id0, buildMessage(id0, list), { rfq: id0, at: new Date().toISOString(), stored: 'local-only',
        rate: rate, rmb_version: version, items: list });
      return;
    }

    el.submit.disabled = true;
    el.submit.textContent = 'Sending…';
    status('Sending your inquiry…', 'run');
    /* 提交目标顺序：① 同源代理路径 /apps/rfq（中国大陆无需代理即可达）② 直连 workers.dev（海外/回滚）
       任一失败自动换下一个，全部失败才走 WhatsApp 兜底；每段都有超时，绝不卡在 Sending */
    var targets = [];
    if (apiProxy) targets.push(apiProxy.replace(/\/+$/, '') + '/inquiry');
    if (api) targets.push(api.replace(/\/+$/, '') + '/inquiry');
    var bodyTxt = JSON.stringify(payload());
    var lastErr = null;
    function attempt(i) {
      if (i >= targets.length) return Promise.reject(lastErr || new Error('no endpoint configured'));
      var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var tid = ctrl ? setTimeout(function () { ctrl.abort(); }, i === 0 ? 8000 : 6000) : null;
      return fetch(targets[i], {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: bodyTxt,
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (r) {
        if (tid) clearTimeout(tid);
        return r.json().then(function (j) { return { status: r.status, j: j }; },
                            function () { return { status: r.status, j: {} }; });
      }, function (e) {
        if (tid) clearTimeout(tid);
        lastErr = e;
        return attempt(i + 1);
      }).then(function (o) {
        if (i < targets.length - 1 && o && o.status >= 500) { lastErr = new Error('HTTP ' + o.status); return attempt(i + 1); }
        return o;
      });
    }
    attempt(0).then(function (o) {
      if (o.status !== 200 || !o.j || !o.j.ok) {
        var why = (o.j && (o.j.error || (o.j.errors || []).join('; '))) || ('HTTP ' + o.status);
        throw new Error(why);
      }
      clearToken();
      status('✓ Inquiry saved — ' + o.j.rfq + '. Tap “Contact Us on WhatsApp” below to continue.', 'ok');
      showDone(o.j.rfq, messageFromServer(o.j), {
        rfq: o.j.rfq, at: new Date().toISOString(), rate: o.j.rate, rmb_version: o.j.version,
        total: o.j.total, pending: o.j.pending, stored: 'backend',
        items: o.j.items
      });
      el.submit.disabled = false;
      el.submit.textContent = 'Send Inquiry';
    }).catch(function (e) {
      var why = (e && (e.name === 'AbortError' ? 'connection timed out' : e.message)) || 'network error';
      errEl.textContent = 'We could not save your list on our server (' + why + '). ' +
        'Your list is still here — tap “Contact Us on WhatsApp” below to send it to us now, or tap Send Inquiry to retry.';
      errEl.hidden = false;
      status('Not saved yet (' + why + ') — your list is safe. Tap “Contact Us on WhatsApp” to send it now.', 'err');
      /* 让错误一定被看见：把抽屉滚到底部（错误提示与 WhatsApp 按钮都在底栏上方） */
      try {
        errEl.scrollIntoView({ block: 'center' });
        if (el.scroll) el.scroll.scrollTop = el.scroll.scrollHeight;
      } catch (e) {}
      el.submit.textContent = 'Try Again — Send Inquiry';
      /* 兜底：立刻给出 WhatsApp 交接（后台没有记录，绝不谎报成功） */
      var idf = rfqId();
      var msgf = buildMessage(idf, list);
      if (waSend) {
        waSend.href = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(msgf);
        waSend.hidden = false;
      }
      el.submit.disabled = false;
      el.submit.textContent = 'Send Inquiry';
    });
  });

  /* 浮动清单按钮：默认收起，点开/关闭，关闭不删商品 */
  if (fab) fab.addEventListener('click', function () { openDrawer(); });

  /* 兜底：抽屉打开时，若手指点在「Send Inquiry」按钮的矩形范围内（可能被浮动按钮/主题浮层挡住而没命中按钮），
     也照样触发提交 —— 真机上"点了没反应"最常见的原因就是命中测试落到了透明浮层上。 */
  document.addEventListener('click', function (ev) {
    var btn = el.submit;
    if (!btn || !el.drawer || el.drawer.hidden || btn.hidden) return;
    if (ev.target === btn || (btn.contains && btn.contains(ev.target))) return;   // 正常命中 → 交给原处理器
    var x = ev.clientX, y = ev.clientY;
    if (x == null || y == null || (x === 0 && y === 0)) return;
    var r = btn.getBoundingClientRect();
    if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
      ev.preventDefault();
      ev.stopPropagation();
      btn.click();
    }
  }, true);
  if (fabN) {
    var syncFab = function () { fabN.textContent = read().length; };
    syncFab();
    setInterval(syncFab, 800);
  }

  paint();
  render();
})();
